
import React, { memo } from 'react';
import { EdgeProps, getBezierPath, BaseEdge } from '@xyflow/react';
import { EdgeData } from './types';

interface WorkflowEdgeProps {
  id: string;
  source: string;
  target: string;
  sourceX: number;
  sourceY: number;
  targetX: number;
  targetY: number;
  sourcePosition?: string;
  targetPosition?: string;
  style?: Record<string, unknown>;
  markerEnd?: string;
  data?: EdgeData;
  selected?: boolean;
}

const WorkflowEdge = ({
  id,
  source,
  target,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  data,
  selected,
}: WorkflowEdgeProps) => {
  // Generate the path for the edge
  const edgePath = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });
  
  // Extract label and condition from data, using defaults if not provided
  const label = data?.label || '';
  const hasCondition = data?.condition_config && Object.keys(data.condition_config).length > 0;

  return (
    <>
      <BaseEdge 
        id={id} 
        path={edgePath} 
        markerEnd={markerEnd}
        style={{
          ...style,
          strokeWidth: selected ? 2 : 1,
          stroke: hasCondition ? 'var(--primary)' : 'var(--border)',
          ...style,
        }}
      />
      
      {label && (
        <text
          x={(sourceX + targetX) / 2}
          y={(sourceY + targetY) / 2 - 10}
          textAnchor="middle"
          style={{ fontSize: '10px', fill: 'var(--foreground)' }}
          dominantBaseline="central"
        >
          {label}
        </text>
      )}
    </>
  );
};

export default memo(WorkflowEdge);
